import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ICON_TYPES } from './iconTypes';
import Icon from './Icon';
import './StepProgress.scss';
var StepProgress = function (_a) {
    var className = _a.className, currentStepValue = _a.currentStepValue, onClick = _a.onClick, steps = _a.steps, props = __rest(_a, ["className", "currentStepValue", "onClick", "steps"]);
    var handleStepClick = function (stepValue) {
        if (onClick) {
            onClick(stepValue);
        }
    };
    var currentStepIndex = steps.findIndex(function (step) { return step.value === currentStepValue; });
    var getStep = function (step, stepIndex) {
        var stepNumber = stepIndex + 1;
        var isFirst = stepIndex === 0;
        var isCurrent = step.value === currentStepValue;
        var isComplete = stepIndex < currentStepIndex;
        var connectorClass = classnames('StepProgress__stepConnector', {
            'StepProgress__stepConnector--isComplete': isComplete,
            'StepProgress__stepConnector--isCurrent': isCurrent
        });
        var stepNumberClass = classnames('StepProgress__stepNumber', {
            'StepProgress__stepNumber--isComplete': isComplete,
            'StepProgress__stepNumber--isCurrent': isCurrent
        });
        var getIcon = function () {
            if (isComplete) {
                return React.createElement(Icon, { color: 'blue', type: 'check' });
            }
            else {
                return step.icon ? React.createElement(Icon, { color: 'white', type: step.icon }) : stepNumber;
            }
        };
        return (React.createElement("button", { className: 'StepProgress__step', "data-testid": "step ".concat(stepNumber, " button"), disabled: isCurrent, key: step.label, onClick: function () { return handleStepClick(step.value); }, type: 'button' },
            isFirst ? null : React.createElement("div", { className: connectorClass }),
            React.createElement("div", { className: stepNumberClass }, getIcon()),
            React.createElement("div", { className: 'StepProgress__stepLabel' }, step.label)));
    };
    var containerClass = classnames('StepProgress', className);
    return (React.createElement("div", __assign({}, props, { className: containerClass }), steps.map(getStep)));
};
StepProgress.defaultProps = {
    onClick: function () { }
};
StepProgress.propTypes = {
    className: PropTypes.string,
    currentStepValue: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    steps: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.oneOf(ICON_TYPES),
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired).isRequired
};
export default StepProgress;
//# sourceMappingURL=StepProgress.js.map